import { filter, map, mergeMap, withLatestFrom } from 'rxjs/operators'
import { environment } from 'src/environments/environment'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { AppState } from '../core.state'
import { settingsActions } from './settings.actions'

@Injectable()
export class SettingsEffects implements OnInitEffects {
  constructor(private actions$: Actions, private store: Store<AppState>) {}

  ngrxOnInitEffects() {
    return settingsActions.initActions()
  }

  initActions = createEffect(() =>
    this.actions$.pipe(
      ofType(settingsActions.initActions),
      mergeMap((action) => {
        return [
          settingsActions.setOneById({
            id: 'primarySidebarVisible',
            value: true
          })
        ]
      })
    )
  )
}
